module.exports = __webpack_public_path__ + "img/status-verify.ca51184c.svg";